import _findBestBreakPoints from "./findBestBreakPoint.js";
import _convertToPlainText from "../quill/convertToPlainText.js";
import _convertToPlainTextCustom from "../quill/convertToPlainTextCustom.js";
const convertToPlainTextCustom = _convertToPlainTextCustom;
const convertToPlainText = _convertToPlainText;
const findBestBreakPoints = _findBestBreakPoints;
const endPunctuation = [".", "?", "!", ":"];
const speakerTags = ["-", "—", "[", ">", "(", "¿"];
const getFirstChar = function (w) {
  let plainText = convertToPlainTextCustom(w, " ", true);
  return plainText.slice(0, 1);
};
const getLastChar = function (w) {
  let plainText = convertToPlainTextCustom(w, " ", true);
  return plainText.slice(w.length - 1);
};
const getLength = function (w) {
  let plainText = convertToPlainTextCustom(w, " ", true);
  return plainText.trim().length;
};
function getLongestLineIndex(lines, whiteSpace) {
  let longestLine = 0;
  let longestLength = 0;
  lines.forEach((line, index) => {
    line = whiteSpace ? convertToPlainText(line.join(" ").trim()) : convertToPlainText(line.join("").trim());
    let length = line.length;
    if (length > longestLength) {
      longestLength = length;
      longestLine = index;
    }
  });
  return longestLine;
}
function getMaxLength(lines, whiteSpace) {
  let longestLength = 0;
  lines.forEach(line => {
    line = whiteSpace ? convertToPlainText(line.join(" ").trim()) : convertToPlainText(line.join("").trim());
    let length = whiteSpace ? line.length : line.length;
    if (length > longestLength) {
      longestLength = length;
    }
  });
  return longestLength;
}
function getBalancedScore(lines, whiteSpace) {
  let lineLengths = lines.map(line => {
    line = whiteSpace ? convertToPlainText(line.join(" ").trim()) : convertToPlainText(line.join("").trim());
    return line.length;
  });
  let deltas = [];
  lineLengths.forEach((lineLength, count, lengths) => {
    if (count < lengths.length - 1) {
      deltas.push(lineLength - lengths[count + 1]);
    }
  });
  return Math.abs(deltas.reduce((partialSum, a) => partialSum + a, 0) / lines.length);
}
function isStartOfCombinedSpeakerTag(currentWord, nextWord) {
  // Check if current word is a dash and next word starts with a bracket
  if ((currentWord === '-' || currentWord === '—') && nextWord && nextWord.startsWith('[')) {
    return true;
  }
  return false;
}

/* Takes event text as html */
export default (function balanceText(html, maxChars, maxLines) {
  if (!html) {
    // console.log("No text provided to balanceText." + text);
    return [''];
  }
  let text = convertToPlainTextCustom(html, " ");
  let whiteSpace = true;
  let prevLines = [];
  let prevBalanceScore = 100000;
  if (text.split(/\s+|(?<=，+)/g).length === 1 && text.length > maxChars) {
    text = convertToPlainText(text, " ");
    whiteSpace = false;
  }
  let words = text.split(" ");
  let lines = whiteSpace ? [text.split(/\s+|(?<=，+)/g)] : [text.split("")];
  let textLines = [];
  let newTextLines = [];
  let textLine = "";
  let processing = false;
  let iterations = 0;
  //Check to see if text contains a speaker tag from the speakerTags array.
  let containsSpeakerTag = words.some(word => {
    return speakerTags.includes(getFirstChar(word));
  });
  let containsEndPunctuation = words.some(word => {
    return endPunctuation.includes(getLastChar(word));
  });
  if (!containsSpeakerTag && !containsEndPunctuation || !whiteSpace) {
    // For whitespace-based text without speaker tags, use linguistic break-point engine
    if (whiteSpace) {
      let wordList = text.split(/\s+/g).filter(w => w.length > 0);
      let plainTextLength = function (t) {
        return convertToPlainText(t, " ").trim().length;
      };
      let result = findBestBreakPoints.findBestBreakPoints(wordList, maxChars, maxLines, plainTextLength);
      return result.map(line => line.trim()).filter(line => line.length > 0);
    }

    // CJK/single-character splitting path (unchanged)
    processing = true;
    while (processing && iterations < 2000) {
      processing = false;
      iterations++;
      prevLines = JSON.parse(JSON.stringify(lines));
      let longestLineIndex = getLongestLineIndex(lines, whiteSpace);
      let word = lines[longestLineIndex].pop();
      if (lines[longestLineIndex + 1]) {
        lines[longestLineIndex + 1].unshift(word);
      } else {
        lines.push([word]);
      }
      lines = lines.filter(line => {
        return line;
      });
      let maxLength = getMaxLength(prevLines, whiteSpace);
      let balanceScore = getBalancedScore(lines, whiteSpace);
      if (maxLength > maxChars) {
        processing = true;
      } else if (balanceScore > prevBalanceScore || prevLines.length === 1) {
        processing = false;
        iterations = 1000;
      } else if (lines.length > maxLines) {
        processing = false;
        iterations = 1000;
      } else {
        processing = true;
      }
      prevBalanceScore = balanceScore;
    }
    prevLines = prevLines.filter(line => {
      return line.length > 0;
    });
    return prevLines.map(line => {
      return whiteSpace ? line.join(" ").trim() : line.join("").trim();
    });
  } else {
    let skipNextWord = false;
    words.forEach((word, index, words) => {
      if (skipNextWord) {
        skipNextWord = false;
        return;
      }
      let firstChar = getFirstChar(word);
      let lastChar = getLastChar(word);
      let nextWord = words[index + 1];

      // Check for combined speaker tag pattern (- [Text])
      if (isStartOfCombinedSpeakerTag(word, nextWord)) {
        if (textLine) {
          textLines.push(textLine);
        }
        textLine = word + " " + nextWord;
        skipNextWord = true;
        return;
      }
      if (endPunctuation.includes(lastChar)) {
        textLine += " " + word;
        textLines.push(textLine.trim());
        textLine = "";
        return;
      }
      if (!textLine) {
        textLine += word;
        return;
      }
      if (speakerTags.includes(firstChar)) {
        textLines.push(textLine);
        textLine = word;
        return;
      }
      if (getLength(textLine) + 1 + getLength(word) > maxChars) {
        textLines.push(textLine);
        textLine = word;
        return;
      }
      textLine += " " + word;
    });

    //Push Remaining text.
    if (textLine) {
      textLines.push(textLine);
    }
    textLines.forEach((line, index, lines) => {
      // console.log("Line: ", line);
      if (getLength(line) > maxChars) {
        /* Line is over the max character limit - use linguistic engine to split */
        let lineWords = line.split(" ").filter(w => w.length > 0);
        let estimatedLines = Math.max(maxLines, Math.ceil(getLength(line) / maxChars));
        let splitLines = findBestBreakPoints.findBestBreakPoints(lineWords, maxChars, estimatedLines, function (t) {
          return getLength(t);
        });

        // Check if we can merge the first split part with the previous line
        if (splitLines.length > 1 && newTextLines.length > 0) {
          let prevLine = newTextLines[newTextLines.length - 1];
          if (!endPunctuation.includes(getLastChar(prevLine)) && !speakerTags.includes(getFirstChar(splitLines[0])) && getLength(prevLine + " " + splitLines[0]) <= maxChars) {
            newTextLines[newTextLines.length - 1] = prevLine + " " + splitLines[0];
            splitLines.shift();
          }
        }

        // Check if we can merge the last split part with the next line
        if (splitLines.length > 1 && lines[index + 1]) {
          let nextLine = lines[index + 1];
          if (!speakerTags.includes(getFirstChar(nextLine)) && getLength(splitLines[splitLines.length - 1] + " " + nextLine) <= maxChars) {
            lines[index + 1] = splitLines.pop() + " " + nextLine;
          }
        }
        splitLines.forEach(sl => newTextLines.push(sl));
      } else {
        newTextLines.push(line);
      }
    });
    return newTextLines;
  }
});